import { forwardRef, type Ref, type SVGProps } from "react";
const IconCloseCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m5.71 18.29a1 1 0 0 1 0 1.42 1 1 0 0 1-1.42 0L16 17.41l-4.29 4.3a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l4.29 4.3 4.29-4.3a1 1 0 0 1 1.42 1.42L17.41 16z" />
  </svg>
);
const ForwardRef = forwardRef(IconCloseCircleFilledSVG);
ForwardRef.displayName = "IconCloseCircleFilled";
export { ForwardRef as IconCloseCircleFilled };
